import { memo } from "react";
import close_img from "../../../../../../assets/games/AmarAkbarAntony/Bet_1.png"

const AmarAkbarAnthonyGameRules = memo((props) => {

    return <div className="AAA_GameRules_Back">
        <div className="AAA_GameRules_main">
            <div className="AAA_GameRulesTitle">
                <span className="titleTxt"><span style={{ color: "#f1ff05" }}>Amar</span> <span>Akbar</span> <span style={{ color: "#f1ff05" }}>Anthony</span></span>
            </div>
            <div className="AAA_GameRules_closeButton" onClick={props.close}>
                <img src={close_img} className="AAA_GameRules_close_image" alt="Close" />
                <p className="AAA_gameRules_Close_Icon">X</p>
            </div>
            <div className="AAA_GameRules_Section">
                <div className="AAA_Game_Limits">
                    <h2 className="AAA_head_title">Limits</h2>
                    <div className="AAA_Limits">
                        <table className="AAA_limits_table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bet Type</th>
                                    <th>Limits</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="AAA_LimitValues">1</td>
                                    <td className="AAA_LimitValues">Amar / Akbar / Anthony</td>
                                    <td className="AAA_LimitValues">{props.innerLimits.split("|")[0]}</td>
                                </tr>
                                <tr>
                                    <td className="AAA_LimitValues">2</td>
                                    <td className="AAA_LimitValues">Minimum Bet</td>
                                    <td className="AAA_LimitValues">{props.minBetAmt}</td>
                                </tr>
                                <tr>
                                    <td className="AAA_LimitValues">3</td>
                                    <td className="AAA_LimitValues">Maximum Bet</td>
                                    <td className="AAA_LimitValues">{props.maxBetAmt}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <hr className="AAA_hr_line" />
                <div className="AAA_Game_Limits">
                    <h2 className="AAA_head_title">How To Play ?</h2>
                    <div className="AAA_gameRules">
                        <p><b>Amar Akbar Anthony</b> is a popular Indian casino game that combines elements of card prediction and strategic betting. The game offers a fun, high-paced experience where players place bets on one of three positions — <b>Amar</b>, <b>Akbar</b>, or <b>Anthony</b> — and win based on the rank of the card drawn from a standard deck.</p>
                        <p><b>Amar Akbar Anthony</b> is often a crowd favorite in Indian casinos, combining the thrill of card games with simple betting mechanics. It has its origins in traditional Indian card games and is known for its quick pace and high energy.</p>
                        <ul>
                            <li>The game uses a standard 52-card deck.</li>
                            <li>There are three betting positions: <b>Amar</b>, <b>Akbar</b>, and <b>Anthony</b>.</li>
                            <ul>
                                <li><b>Amar</b> covers cards from <b>A</b> to <b>6</b></li>
                                <li><b>Akbar</b> covers cards from <b>7</b> to <b>10</b></li>
                                <li><b>Anthony</b> covers cards from <b>J</b> to <b>K</b></li>
                            </ul>
                            <li><b>Place Your Bet:</b> Choose one of the three positions — Amar, Akbar, or Anthony — and place your bet. Each position corresponds to a different range of cards.</li>
                            <li><b>Draw the Card:</b> Once player have placed their bets, a single card is drawn from a shuffled deck.</li>
                            <li><b>Determine the Winner:</b></li>
                            <ul>
                                <li>If the drawn card falls within the range of your bet, you win!</li>
                                <li>If the card falls within the range of any other position, that position wins.</li>
                            </ul>
                        </ul>
                    </div>
                </div>
                <hr className="AAA_hr_line" />
                <div className="AAA_Game_Limits">
                    <h2 className="AAA_head_title">Payouts</h2>
                    <table className="AAA_payoutTable">
                        <thead>
                            <th>Win Combination</th>
                            <th>Prize</th>
                        </thead>
                        <tbody>
                            {props.payoutInfo.map((ele) => <tr key={ele}>
                                <td>{ele.key}</td>
                                <td>{ele.value}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
})

export default AmarAkbarAnthonyGameRules